import React from "react";
import { Link } from "react-router-dom";

export default function Welcome({ user }) {
  console.log(user);
  return <></>;
}
